import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { FormGridObject, FormSettingsGridObject, FormSettingsUpdateInput, OkObject } from '@it2go/types';
import { filterFrag } from './types/filter.types';
import { formSettingsFrag } from './types/form.types';
import { FolderFormGridObject } from '@libs/types/src/services/object-type/form/folder-form.object';
import {
    FolderFormDataAssignWorkInput,
} from '@libs/types/src/services/input-type/forms/folder-form-data.assign-work-input';

@Injectable({ providedIn: 'root' })
export class FormGqlServiceV2 extends GqlServiceV2 {

    public getFormSettings(input: GridInput | null) {
        return this.query<FormSettingsGridObject>(
            `
                query($input: GridInput) {
                    formSettings {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${formSettingsFrag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateFormSettings(input: FormSettingsUpdateInput) {
        return this.mutate(
            `
                mutation($input: FormSettingsUpdateInput!) {
                    formSettings {
                        update(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getFormsV2(input: GridInput | null, frag: string) {
        return this.query<FormGridObject>(`
                query($input: GridInput) {
                    formV2 {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getFolderFormsV2(input: GridInput | null, frag: string) {
        return this.query<FolderFormGridObject>(`
                query($input: GridInput) {
                    folderFormV2 {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public assignFolderFormDataAssignWork(input: FolderFormDataAssignWorkInput) {
        return this.mutate<OkObject>(`
                mutation($input: FolderFormDataAssignWorkInput!) {
                    folderFormDataV2 {
                        assignToWork(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

}
